import { render } from "./itemList.vue?vue&type=template&id=e28979ec"
import script from "./itemList.vue?vue&type=script&lang=js"
export * from "./itemList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__